import * as z from "zod/v4";

export enum MerchantRecommendedExchangeGroupingType {
  COLLECTION = "collection",
  TAG = "tag",
}

export const ProductExchangeGuidanceSchema = z.object({
  productId: z.string(),
  exchangeGuidance: z.string(),
});
export type ProductExchangeGuidance = z.infer<
  typeof ProductExchangeGuidanceSchema
>;

export const MerchantRecommendedExchangeSchema = z.object({
  groupingType: z.enum(MerchantRecommendedExchangeGroupingType),
  groupingId: z.string(),
  productExchangeGuidance: z.array(ProductExchangeGuidanceSchema),
  groupingExchangeGuidance: z.string(),
  enabled: z.boolean(),
});
export type MerchantRecommendedExchange = z.infer<
  typeof MerchantRecommendedExchangeSchema
>;

export function areProductExchangeGuidanceEqual(
  a: ProductExchangeGuidance,
  b: ProductExchangeGuidance,
): boolean {
  return (
    a.productId === b.productId && a.exchangeGuidance === b.exchangeGuidance
  );
}

export function areMerchantRecommendedExchangeIdentifiersEqual(
  a: MerchantRecommendedExchange,
  b: MerchantRecommendedExchange,
): boolean {
  return a.groupingType === b.groupingType && a.groupingId === b.groupingId;
}

export function areMerchantRecommendedExchangeEqual(
  a: MerchantRecommendedExchange,
  b: MerchantRecommendedExchange,
): boolean {
  if (
    !areMerchantRecommendedExchangeIdentifiersEqual(a, b) ||
    a.enabled !== b.enabled ||
    a.groupingExchangeGuidance !== b.groupingExchangeGuidance ||
    a.productExchangeGuidance.length !== b.productExchangeGuidance.length
  ) {
    return false;
  }

  return a.productExchangeGuidance.every((guidanceA) =>
    b.productExchangeGuidance.some((guidanceB) =>
      areProductExchangeGuidanceEqual(guidanceA, guidanceB),
    ),
  );
}
